<template>
  <div class="column upload-card">
    <div class="file-label">
      <img
        class="row center--img"
        src="/assets/images/sources/folder-check-outline.png"
      />
      <label v-show="!showEditFile" class="row column message-drag">
        {{ $t('DOCUMENT_SOURCES.FILE_NAME') }}:
        <b>
          <u>{{ fileName }}</u>
        </b>
        <woot-button
          v-tooltip.top="$t('DOCUMENT_SOURCES.ACTIONS.EDIT.BUTTON_TEXT')"
          size="medium"
          color-scheme="primary"
          class-names="edit-button"
          variant="clear"
          icon="edit"
          @click.prevent="editFileName"
        />
      </label>
      <div v-show="showEditFile" class="row relative">
        <label class="input-group-merge input-group-merge-left">
          {{ $t('DOCUMENT_SOURCES.FILE_NAME') }}:
        </label>
        <input
          ref="name"
          v-model="fileName"
          type="text"
          class="input-with-leading-and-trailing"
        />
        <div class="input-group-merge input-group-merge-right">
          <woot-button
            size="small"
            color-scheme="success"
            class-names="edit-button"
            variant="clear"
            icon="checkmark"
            @click.prevent="saveFileName"
          />
          <woot-button
            size="small"
            color-scheme="alert"
            class-names="edit-button"
            variant="clear"
            icon="dismiss"
            @click.prevent="revertFileName"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import alertMixin from 'shared/mixins/alertMixin';
import { getFileName } from 'helpers/FileHelper';
import { nextTick } from 'vue';
import { lastSegmentOfUrl } from '../../../../../helper/URLHelper';

export default {
  mixins: [alertMixin],
  props: {
    file: {
      type: [Object, File],
    },
    url: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showEditFile: false,
      fileName: '',
    };
  },
  mounted() {
    if (this.file) {
      this.fileName = getFileName(this.file);
    } else if (this.url) {
      this.fileName = lastSegmentOfUrl(this.url);
    }
    this.$emit('on-edit-file-name', this.fileName);
  },
  methods: {
    editFileName() {
      this.showEditFile = true;
      nextTick(() => {
        this.$refs.name.focus();
      });
    },
    saveFileName() {
      this.showEditFile = false;
      this.$emit('on-edit-file-name', this.fileName);
    },
    revertFileName() {
      if (this.file) {
        this.fileName = getFileName(this.file);
      }
      else if (this.url) {
        this.fileName = this.url;
      }
      this.showEditFile = false;
    },
  },
};
</script>
<style scoped lang="scss">
.file-label {
  padding-top: var(--space-large);
  padding-bottom: var(--space-large);
  width: 90%;
}
.upload-card {
  margin: 0 0 1.6rem;
  padding: var(--space-large);
  border: 1px solid var(--s-75);
  display: flex;
  flex-direction: column;
  align-items: center;
  background: var(--s-25);
  height: var(--space-giga);
}

.center--img {
  margin: auto;
  height: var(--space-jumbo);
}
.message-drag {
  color: var(--w-500);
  text-align: center;
}
.edit-button {
  background-color: var(--s-25);
  &:hover {
    background-color: var(--s-25);
  }
}
.input-with-leading-and-trailing {
  border-radius: var(--border-radius-full);
  width: 100%;
  border: 1px solid var(--s-200);
  padding-left: var(--space-mega);
  padding-right: var(--space-mega);
  border-color: var(--w-500);
  color: var(--w-500);
  font-weight: bold;
  text-align: center;
  margin: 0;
}
.input-group-merge {
  position: absolute;
  display: flex;
  align-items: center;
  top: 0px;
  bottom: 0px;
}
.input-group-merge-left {
  left: 0px;
  padding-left: var(--space-normal);
}
.input-group-merge-right {
  right: 0px;
  padding-right: var(--space-one);
}
.relative {
  position: relative;
}
</style>
